import { render, staticRenderFns } from "./ReportOrdenesGeneradas.vue?vue&type=template&id=a4d04562"
import script from "./ReportOrdenesGeneradas.vue?vue&type=script&lang=js"
export * from "./ReportOrdenesGeneradas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports